import { createDraftSafeSelector } from '@reduxjs/toolkit';

import type { RootState } from '../..';
import {
  delayResponsesAdapter,
  functionsAdapter,
  parametersAdapter,
} from './adapters';

export const delayResponsesSelectors = delayResponsesAdapter.getSelectors();
export const parametersSelectors = parametersAdapter.getSelectors();
export const functionsSelectors = functionsAdapter.getSelectors();

const functionsState = (state: RootState) => state.functions;

export const selectFunctions = createDraftSafeSelector(
  [functionsState],
  ({ functions }) => {
    return functionsSelectors.selectAll(functions);
  },
);

export const selectActiveFunctions = createDraftSafeSelector(
  [functionsState],
  ({ functions }) => {
    return functionsSelectors.selectAll(functions).filter(f => !f.archived);
  },
);
